export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"google-site-verification","content":"C5E44d3gNNRM5sNbRAXUVETSNqjyWgbu_BzLzJvGbnI"}],"link":[{"rel":"preconnect","href":"https://staticw2.yotpo.com"},{"rel":"preconnect","href":"https://api-cdn.yotpo.com"},{"rel":"preconnect","href":"https://api.unifaun.com"},{"rel":"icon","type":"image/x-icon","href":"/ullmax_faviconv2.png"}],"style":[],"script":[{"src":"https://staticw2.yotpo.com/s6ep0BJlSSjyoi8K2TUCJFgtrzogGwICBSe9114B/widget.js","async":true},{"src":"https://api.unifaun.com/rs-extapi/v1/delivery-checkouts-widget/unifaun-checkout-all.min.js","async":true}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false